export const DBConfig = {
  name: "Diktafont",
  version: 1,
  objectStoresMeta: [
    {
      store: "notes",
      storeConfig: { keyPath: "id", autoIncrement: true },
      storeSchema: [
        { name: "name", keypath: "name", options: { unique: false } },
        { name: "text", keypath: "text", options: { unique: false } },
        {
          name: "dateTime",
          keypath: "dateTime",
          options: { unique: false },
        },
      ],
    },
  ],
};
